export const soaps = [
  {
    name: "Charcoal",
    price: "80",
    description:
      "Charcoals help in removing the dirt, from the pores and give your skin a thorough cleansing. Also control the oil secretion in your skin, making it perfect for skin prone to blackheads .",
    image: require(`../images/charcoalsoap.jpg`),
  },
  {
    name: "Dove",
    price: "80",
    description: `Effective Skin Cleanser: ...
        Provides Hydration: ...
        Dove Soap Is A Natural Moisturizer: ...
        Dove Soap Provides Complete And Balanced Nourishment: ...
        Dove Soap Is Anti-Allergi`,
    image: require(`../images/dovesoap.jpg`),
  },
  {
    name: "Lemon & Mint",
    price: "80",
    description: `Lemon juice has mild bleaching properties that fade acne scars, contains vitamin C which boosts the healing process of your skin.
      Mint leaves contain salicylic acid, which treats and prevents acne.`,
    image: require(`../images/lemonmintsoap.jpg`),
  },
  {
    name: "Aloe Vera",
    price: "80",
    description: `Aloe is ideal for sunburned or irritated skin. "The aloe vera gel features cooling properties that can be soothing for skin that has been exposed to the sun for a long period of time, "In general, aloe can be used to reduce skin irritation and inflammations such as acne and eczema."`,
    image: require(`../images/aloevera.jpg`),
  },
  {
    name: "Coffee",
    price: "80",
    description: `Coffee has antimicrobial properties that may protect the skin against germs. Coffee grounds make a great exfoliant. The grounds do not dissolve in water, which makes them good at scrubbing away dead skin cells. It also lightens the tan skin.`,
    image: require(`../images/coffeesoap.jpg`),
  },
  {
    name: "Lavender",
    price: "80",
    description: `Lavender oil not only boosts potent anti-inflammatory properties, but is also ultra soothing for skin with a therapeutic scent. ... Lavender oil not only moisturizes skin, but is also antibacterial and can kill bacteria that penetrate your pores. That makes lavender oil perfect for preventing and also healing acne.`,
    image: require(`../images/lavendersoap.jpg`),
  },
  {
    name: "Chandan",
    price: "80",
    description: "",
    image: require(`../images/chandansoap.jpg`),
  },
  {
    name: "Multani Miti",
    price: "80",
    description: `Used as a scrub, multani mitti can slough away dead skin cells and remove blackheads and whiteheads, giving skin a natural and healthy glow. Boosts circulation and improves skin health and tone.`,
    image: require(`../images/multanimiti.jpg`),
  },
  {
    name: "Neem",
    price: "80",
    description: `Natural and Herbal handmade Protect sensitive skin from Infection Natural skin toner which removes pigmentation, blackheads, whiteheads, acne and scars.
    Natural moisturizer
    Skin fresh and odor free Removes impurities from skin
    It makes skin soft, gentle and smooth`,
    image: require(`../images/neemsoap.jpg`),
  },
  {
    name: "Goat Milk Soap",
    price: "80",
    description: "",
    image: require(`../images/goatmilksoap.jpg`),
  },
  {
    name: "Kesari",
    price: "80",
    description: "",
    image: require(`../images/soaps.jpg`),
  },
  {
    name: "Papaya",
    price: "80",
    description: `Papaya soap is rich in vitamin C, an antioxidant that can reduce irregular pigmentation and stimulate collagen production. The soap also contains vitamin A, another important nutrient for the skin. It promotes the production of new skincells, and may help reduce dark spots, blemishes, and scars.`,
    image: require(`../images/pappayasoap.jpg`),
  },
  {
    name: "Red Wine",
    price: "80",
    description: `This soap gives good lather that will clean your whole body. Resveratrol, found in grape skin, provides you with anti-inflammatory and anti-fungal properties. Polyphenols in red wine can help reduce the appearance of fine lines and wrinkles. The soap's scent is all natural, provided by the fruity scent of the wine.`,
    image: require(`../images/redwinesoap.jpg`),
  },
  {
    name: "Ubtan",
    price: "80",
    description: "",
    image: require(`../images/ubtansoap.jpg`),
  },
  {
    name: "Honey Milk Soap",
    price: "80",
    description: `Honey and Milk are Good for Skin. Honey has a lot to offer. ...Fades Scar. The anti inflammatory and antibacterial properties of honey help in decreasing the appearance of scars on the skin. ...Cleanses Skin. ...Fights Acne. ...Exfoliates Skin. ...Improves Complexion. ...Purifies and Moisturize Skin. ...Prevents Irritation.`,
    image: require(`../images/honeymilksoap.jpg`),
  },
  {
    name: "Potato Soap",
    price: "80",
    description: `Potato is a rich source of Vitamin B6 & Vitamin C which helps in the growth of skin cells and calms down the skin. It can also help in reducing the dark spots and tanning as it is known to be a cleansing agent`,
    image: require(`../images/potatosoap.jpg`),
  },
  {
    name: "Pink Clay Soap",
    price: "80",
    description: `Pink Clay is rich in Silica, which may help to improve skin elasticity and cell renewal, resulting in supple, younger-looking skin. Gently exfoliating and light on the skin, Pink Clay leaves skin feeling silky-soft and smooth. Plus, it can help to minimise blackheads and promote a radiant and balanced complexion.`,
    image: require(`../images/pinkclaysoap.jpg`),
  },
  {
    name: "Rose Petal Soap",
    price: "80",
    description: `Soothes skin: The natural oils found in roses help retain moisture in the skin. This results in your skin feeling smooth and soft. The sugars in rose petals especially benefit those with sensitive skin. Acts as sunscreen: A rich source of vitamin C, rose petals act as an excellent sunblock.`,
    image: require(`../images/rosepetalsoap.jpg`),
  },
  {
    name: "Toy Soap",
    price: "100",
    description: "",
    image: require(`../images/toysoap.jpeg`),
  },
  {
    name: "Cupcake Soap",
    price: "70",
    description: `They are skin friendly.
      100% safe for Kids.`,
    image: require(`../images/cupcakesoap.jpg`),
  },
  {
    name: "Donut Soap",
    price: "75",
    description: `They are skin friendly.
      100% safe for Kids.`,
    image: require(`../images/donutsoap.jpg`),
  },
  {
    name: "Loofah Soap",
    price: "80",
    description: `The Loofah sponge is composed of slightly rough fibers that are very helpful to exfoliate your skin. In addition to this, it is also beneficial for you to eliminate dead skin cells that will automatically give you smooth, youthful as well as glowing skin.`,
    image: require(`../images/loofahsoap.jpg`),
  },
  {
    name: "Skin Tightening Soap",
    price: "80",
    description: `While aging skin becomes loose so to make reduce this can be used.
      Benefits - Special Ingredients added.
      How often to be used - Daily for better results!!`,
    image: require(`../images/skintighteningsoap.jpg`),
  },
  {
    name: "Fairness Soap",
    price: "80",
    description: `it makes skin tone brighter.
      Benefits - Special Ingredients added for more glowing and brightning skin.
      How often to be used - Daily for better results!!`,
    image: require(`../images/fairnesssoap.jpg`),
  },
  {
    name: "Anti Tan Soap",
    price: "80",
    description: `removes tan from skin naturally.
      Benefits - Special Ingredients added to remove tan from your skin
      How often to be used - Daily for better results!!`,
    image: require(`../images/antitansoap.jpg`),
  },
  {
    name: "Letter Soap",
    price: "100",
    description: ``,
    image: require(`../images/IMG_20210804_173732.jpg`),
  },
  {
    name: "Monogram Letter Soap",
    price: "25",
    description: `Gift personalised Initials or Full name Soap to your close ones!!. Preferred upto  7 letter name. Cost Rs 25/- for each letter`,
    image: require(`../images/lettersoap.jpg`),
  },
  {
    name: "Photo Soap",
    price: "100",
    description: "",
    image: require(`../images/photosoap.jpeg`),
  },
  {
    name: "Green Tea Soap",
    price: "80",
    description: `Rich in Antioxidants.
      Helps Protect Skin.
      Contains Vitamins for a Healthy Glow.
      Reduces Damaging Effects of Free Radicals that cause Premature Aging.
      Softens & Smoothes Skin.
      Natural Ingredients.
      `,
    image: require(`../images/greenteasoap.jpg`),
  },
  {
    name: "Candy soap",
    price: "100",
    description: "",
    image: require(`../images/IMG_20210804_173842.jpg`),
  },
];
export const perfumes = [
  {
    name: "Golden Vanila",
    price: "500",
    description: "",
    image: require(`../images/goldenvanilaperfume.jpeg`),
  },
  {
    name: "Ferrari",
    price: "775",
    description: `This one comes with a strong and mild sweet fragrance
    Can be used - Unisex
    Totally mesmerizing fragrance..`,
    image: require(`../images/perfumeferrrari.jpg`),
  },
  {
    name: "Romance",
    price: "700",
    description: "",
    image: require(`../images/romanceperfume.webp`),
  },
  {
    name: "Havc",
    price: "400",
    description: "",
    image: require(`../images/havcperfume.jpg`),
  },
  {
    name: "David off",
    price: "350",
    description: "",
    image: require(`../images/davidoffperfume.jpg`),
  },
  {
    name: "White musk",
    price: "350",
    description: "",
    image: require(`../images/whitemuskperfume.jpg`),
  },
  {
    name: "Melody",
    price: "450",
    description: "",
    image: require(`../images/melodyperfume.jpg`),
  },
  {
    name: "212 VIP",
    price: "450",
    description: "",
    image: require(`../images/212VIP.jpg`),
  },
  {
    name: "Oudh",
    price: "450",
    description: "",
    image: require(`../images/oudhperfume.jpg`),
  },
  {
    name: "CK 1",
    price: "450",
    description: `Brand: Calvin Klein
      Content: 40ml
      Fragrance: Fruity
      Unisex perfume with a mild and lingering fragrance
      Ideal for daily wear
      Clear and transparent bottle`,
    image: require(`../images/ck1.jpg`),
  },
  {
    name: "Prophecy",
    price: "500",
    description: "",
    image: require(`../images/prophecyperfume.jpg`),
  },
  {
    name: "Keress",
    price: "525",
    description: "Classic And Mesmerizing Fragrance.",
    image: require(`../images/karessperfume.jpg`),
  },
  {
    name: "Gucci Bamboo",
    price: "720",
    description: "",
    image: require(`../images/guccibambooperfume.jpg`),
  },
  {
    name: "Classic Jaguar",
    price: "550",
    description: "",
    image: require(`../images/classicjaguarperfume.jpg`),
  },
  {
    name: "Bad Boy",
    price: "500",
    description: `Unisex (Smell you won't ever Forget)`,
    image: require(`../images/badboyperfume.jpg`),
  },
  {
    name: "Green Irish",
    price: "500",
    description: `Unisex (Smell you won't ever Forget)`,
    image: require(`../images/greenirishperfume.jpg`),
  },
  {
    name: "Fog Black",
    price: "700",
    description: "",
    image: require(`../images/fogblackperfume.jpg`),
  },
  {
    name: "Ellie Saab",
    price: "850",
    description: "Classic And Mesmerizing Fragrance.",
    image: require(`../images/ellesaabperfume.jpg`),
  },
  {
    name: "Poisn by Dior",
    price: "900",
    description: "Classic And Mesmerizing Fragrance.",
    image: require(`../images/poisnbydiorperfume.jpg`),
  },
  {
    name: "Blue Wave",
    price: "400",
    description: `Unisex (Smell you won't ever Forget)`,
    image: require(`../images/bluewaveperfume.jpg`),
  },
  {
    name: "Invictus",
    price: "500",
    description: "",
    image: require(`../images/invictusperfume.jpg`),
  },
  {
    name: "Figo Black",
    price: "650",
    description: "",
    image: require(`../images/figoblackperfume.jpg`),
  },
  {
    name: "Nazneen",
    price: "550",
    description: "",
    image: require(`../images/nazneenperfume.jpg`),
  },
  {
    name: "Dark Tempt",
    price: "500",
    description: "",
    image: require(`../images/darktemptperfume.jpg`),
  },
  {
    name: "Relax",
    price: "550",
    description: "",
    image: require(`../images/relaxperfume.jpg`),
  },
  {
    name: "Victoria Secret",
    price: "600",
    description: "",
    image: require(`../images/victoriasecretperfume.jpg`),
  },
  {
    name: "Nuti Dissey By Issey Miyake",
    price: "900",
    description: `100ml classy looking strong fragrance by ISSEY MIYAKE

      Nuti Dissey.
      
      This comes in 100ml bottles strong n elegant looking design.
      `,
    image: require(`../images/issemeyakimenperfume.jpg`),
  },
  {
    name: "Brut",
    price: "900",
    description: `Fragrance with Sweet and strong!!
      Stays forever with you!!`,
    image: require(`../images/brutperfume.jpg`),
  },
  {
    name: "Signature",
    price: "750",
    description: `Fragrance with Sweet and Fruity!!
      Totally summer feelss!!`,
    image: require(`../images/signatureperfume.jpg`),
  },
  {
    name: "Red-Black",
    price: "800",
    description: `Fragrance with Strong as wood!!
      Tougher look wear your smell..`,
    image: require(`../images/redblackperfume.jpg`),
  },
  {
    name: "Creations",
    price: "550",
    description: "Winter Fragrance for you all....",
    image: require(`../images/creationsperfume.jpg`),
  },
  {
    name: "Madrid",
    price: "600",
    description: "Winter Fragrance for you all....",
    image: require(`../images/madridperfume.jpg`),
  },
  {
    name: "Issimiyaki men",
    price: "650",
    description: `Get summer refreshing fragrance
      "issimiyaki men"`,
    image: require(`../images/issimiyakimenperfume.webp`),
  },
  {
    name: "Chance",
    price: "700",
    description: `Chance - Winter ❄ smell of blossom flowers 🌸 that sweet touch...

      This Fragrance as sweet as flower smelling around the garden....
      `,
    image: require(`../images/chanceperfume.jpg`),
  },
];
export const pocketPerfumes = [
  {
    name: "",
    price: "100 (10 ml)",
    description: "",
    image: require(`../images/pocketperfume.jpeg`),
  },
];
export const attar = [
  {
    name: "Mogra",
    price: "120 (12 ml)",
    description: "",
    image: require(`../images/mograattar.jpeg`),
  },
  {
    name: "Chandan",
    price: "120 (12 ml)",
    description: "",
    image: require(`../images/chandanattar.jpeg`),
  },
  {
    name: "Kesar",
    price: "120 (12 ml)",
    description: "",
    image: require(`../images/kesarattar.jpeg`),
  },
  {
    name: "Khas",
    price: "120 (12 ml)",
    description: "",
    image: require(`../images/khasattar.jpeg`),
  },
  {
    name: "Classic Jasmin",
    price: "120 (12 ml)",
    description: "",
    image: require(`../images/classicjasminattar.jpeg`),
  },
  {
    name: "Kasturi",
    price: "120 (12 ml)",
    description: "",
    image: require(`../images/kasturiattar.jpeg`),
  },
  {
    name: "Gulab",
    price: "200 (6 ml)",
    description: "",
    image: require(`../images/gulabattar.jpeg`),
  },
  {
    name: "Kewda",
    price: "200 (12 ml)",
    description: "",
    image: require(`../images/kewdaattar.jpeg`),
  },
  {
    name: "Heena",
    price: "120 (12 ml)",
    description: `Homemade Attar - HEENA
      MOST DEMANDING ATTAR Quantity : 6ml`,
    image: require(`../images/heenaattar.jpg`),
  },
];
export const facialbombs = [
  {
    name: "Goat Milk",
    price: "12",
    description: `Facial bombs are the BEST SELLERS OF Bottles heaven
    gives glowing skin and healthy-looking skin in just 15 minutes like facial.`,
    image: require(`../images/goatmilkfacialbomb.jpeg`),
  },
  {
    name: "Charcoal",
    price: "12",
    description: `Made with natural ingredients and 100% results
     Facial bombs are the BEST SELLERS OF Bottles heaven
gives glowing skin and healthy-looking skin in just 15 minutes like facial.`,
    image: require(`../images/charcoalfacialbomb.jpg`),
  },
  {
    name: "Red Wine",
    price: "12",
    description: `Made with natural ingredients and 100% results
     Facial bombs are the BEST SELLERS OF Bottles heaven
gives glowing skin and healthy-looking skin in just 15 minutes like facial.`,
    image: require(`../images/redwinefacialbomb.jpg`),
  },
  {
    name: "Neem Tulsi",
    price: "12",
    description: `Facial bombs are the BEST SELLERS OF Bottles heaven
    gives glowing skin and healthy-looking skin in just 15 minutes like facial.`,
    image: require(`../images/neemtulsifacialbomb.jpeg`),
  },
  {
    name: "Multani Miti",
    price: "12",
    description: `Facial bombs are the BEST SELLERS OF Bottles heaven
    gives glowing skin and healthy-looking skin in just 15 minutes like facial.`,
    image: require(`../images/multanifacialbomb.jpeg`),
  },
  {
    name: "Gold",
    price: "12",
    description: `Facial bombs are the BEST SELLERS OF Bottles heaven
    gives glowing skin and healthy-looking skin in just 15 minutes like facial.`,
    image: require(`../images/goldfacialbomb.jpeg`),
  },
  {
    name: "Mix Fruit",
    price: "12",
    description: `made with natural ingredients and 100% results Facial bombs are the BEST SELLERS OF Bottles heaven
    gives glowing skin and healthy-looking skin in just 15 minutes like facial.`,
    image: require(`../images/mixfruitfacialbomb.jpg`),
  },
  {
    name: "Diamond",
    price: "12",
    description: `Facial bombs are the BEST SELLERS OF Bottles heaven
    gives glowing skin and healthy-looking skin in just 15 minutes like facial.`,
    image: require("../images/diamondfacialbomb.jpeg"),
  },
  {
    name: "Aloevera",
    price: "12",
    description: `Facial bombs are the BEST SELLERS OF Bottles heaven
    gives glowing skin and healthy-looking skin in just 15 minutes like facial.`,
    image: require("../images/aloeverafacialbomb.jpeg"),
  },
];
export const facewash = [
  {
    name: "Coffee Walnut",
    price: "120",
    description: `Coffee can use it to exfoliate, treat acne, increase blood flow, it gives smooth skin prevents from spots on skin.
      Walnut helps in Reduces Dullness To A Great Extent
      Takes Care Of Tanned Skin Really Well.
      Perfect To Treat Acne
      Removes Dead Skin
      Works Best In Removing Blackheads
      Helps Get Rid Of Flaky Skin.`,
    image: require(`../images/coffeewalnutfacewash.jpg`),
  },
  {
    name: "Neem ",
    price: "120",
    description: `Neem, a plant that has multiple curing and healing elements is not just limited to infections but also helps fight acne and dry skin. It’s an age-old remedy used to cure zits, pimples, rashes, and dry skin. the neem face wash also has healing property, gives smooth texture to the skin, and cures dry skin`,
    image: require(`../images/neemfacewash.jpg`),
  },
  {
    name: "Bridal(Sandal wood)",
    price: "120",
    description: `Benefits -
      #1Lightens blemishes.
      #2 Cleanses your pores.
      #3 Heals dry and dull skin.
      #4 Prevents breakouts.
      #5 Fights ageing.`,
    image: require(`../images/sandalwoodfacewash.jpg`),
  },
  {
    name: "Charcoal",
    price: "120",
    description: ` Charcoal removes excessive oils and purifies the skin. Charcoal helps in opening up the clogged pores and removing the whiteheads. Charcoal wipes out bacteria, dirt, impurities, toxins caused due to excessive exposure to pollution from your skin.`,
    image: require(`../images/charcoalfacewash.jpg`),
  },
  {
    name: "Strawberry",
    price: "120",
    description: `They have anti-inflammatory, and anti-oxidants properties that treat burns, protect your skin from UV rays, Strawberry helps in slow ageing process. Strawberry that helps you get rid of dead skin cells. Those who have acne can use strawberries to get rid of the skin condition.`,
    image: require(`../images/strawberryfacewash.webp`),
  },
];
export const bathsalts = [
  {
    name: "Lavender",
    price: "200",
    description: `Moisturizes the skin. Soaking in a warm saltsolution, even just once a week for 15-20 minutes, offers great benefits in terms of improving the skin barrier function, hydrating the skin, and decreasing inflammation. ...Decreases stress. ...Helps insomnia. ...Offers vital healing properties. ...Soothes pain.`,
    image: require(`../images/lavenderbathsalt.jpg`),
  },
  {
    name: "Rose",
    price: "200",
    description: "",
    image: require(`../images/rosebathsalt.jpg`),
  },
  {
    name: "Lemon",
    price: "200",
    description: "",
    image: require(`../images/lemonbathsalt.jpg`),
  },
  {
    name: "Rainbow",
    price: "200",
    description: "",
    image: require(`../images/rainbowbathsalt.jpg`),
  },
  {
    name: "Bubblegum",
    price: "200",
    description: "",
    image: require(`../images/bubblegumbathsalt.jpeg`),
  },
];
export const faceserum = [
  {
    name: "24k Gold",
    price: "500 (30 ml)",
    description: "Gives absolute stunning shine & nourishes skin",
    image: require(`../images/24kgoldfaceserum.jpg`),
  },
  {
    name: "Natural",
    price: "220",
    description: `Absorbs quickly into your skin. Serums are lighter skin care formulations than moisturizers. The thinner viscosity allows the serum to be absorbed more easily into your skin. This makes a face serum an ideal first step in the layering process.Soothes sensitive skin. Improves the appearance of fine lines and wrinkles. Some face serums contain ingredients like retinol that may help reduce the appearance of fine lines and wrinkles.Protects your skin from free radicals and future damage. Has the potential to provide more visible results. Feels light on your skin. Because they absorb quickly into your skin, a face serum doesn’t feel heavy or greasy.`,
    image: require(`../images/naturalfaceserum.jpg`),
  },
  {
    name: "Hyaluronic Acid serum",
    price: "350",
    description: `It helps to keep skin hydrated and looking young.
    A serum with hyaluronic acid can improve the appearance of wrinkles and fine lines.
    It can also help to improve skin tone and texture.
    Helps to retain moisture in the skin.
    It can be effective in treating dry skin conditions.`,
    image: require(`../images/hyaluronicacidserum.jpg`),
  },
];
export const hairmask = [
  {
    name: "Castor oil Aloevera ",
    price: "350 (50 gm)",
    description:
      " Get smooth and soft hair with Bottles Heaven CatorAloe Hair mask",
    image: require(`../images/castoroilaloverahairmask.jpg`),
  },
  // {
  //   name: "Keratin Hair Mask ",
  //   price: "270",
  //   description:
  //     " Keratin smooths cells that overlap to form hair strands, which means more manageable hair and less frizz. This makes for hair that dries with little frizz and has a glossy, healthy look to it. Keratin can also reduce the look of split ends by temporarily bonding the hair back together.",
  //   image: require(`../images/keratinhairmask.jpg`),
  // },
];
export const lipcare = [
  {
    name: "Rose Bud Lip Scrub",
    price: "60",
    description: `Dry Lips  Don't worry we got you scrub to remove dryness from your lips and make it soft like baby lips!! Customisation is availabe`,
    image: require(`../images/rosebudlipscrub.jpg`),
  },
  {
    name: "Honey Blossom Lip Balm",
    price: "60",
    description: `To make it extra care for your lips we got your lips safe with Lip Balm. Customisation is available`,
    image: require(`../images/honeyblossomlipbalm.jpg`),
  },
];
export const bodybutter = [
  {
    name: "Rose Body Butter",
    price: "350",
    description: ` Dry Skin during winter
      Don't worry we got this for you..
      Instant free from dryness during winter note - not to apply over FACE.`,
    image: require(`../images/rosebodybutter.jpg`),
  },
];
export const ubtanpowder = [
  {
    name: "Ubtan powder",
    price: "110",
    description: "get fair and glowing skin",
    image: require(`../images/ubtanpowder.jpg`),
  },
];
export const hampers = [
  {
    image: require(`../images/hamper2.jpg`),
  },
  {
    image: require(`../images/hamper1.jpg`),
  },
  {
    image: require(`../images/hamper4.jpg`),
  },
  {
    image: require(`../images/IMG_20211026_212340.jpg`),
  },
];
